import React from "react";
import BaseComponent from './baseComponent'
import ResetComponentPassword from './ResetComponentPassword'
import Utils from "../../utility";
import {connect} from "react-redux";
import {history} from "../../managers/history";

class ResetPassword extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            emailError: "",
            recoverycode: "",
            recoverycodeError: "",
            password: "",
            passwordError: "",
            confirmPassword: "",
            confirmPasswordError: ""
        }
    }

    componentDidMount() {
        if(!this.props?.user?.IsLoggedIn)
       return history.push('/')
    }

    onChangeEvent = (event) => {
        this.setState({[event.target.id]: event.target.value});
    };

    togglePassword = (event) => {
        this.setState({isPasswordVisible: !this.state.isPasswordVisible});
    };


    validateResetPasswordForm = () => {
        this.setState({
            emailError: Utils.isEmpty(this.state.email) ? "Please Enter Email Address" : (Utils.validateEmail(this.state.email) ? "" : "Invalid email address"),
            recoverycodeError:Utils.isEmpty(this.state.recoverycode) ? "Please Enter Recovery Code": (Utils.validateRecoverycode(this.state.recoverycode) ? "" : "Invalid Recovery Code"),
            passwordError: Utils.isPasswordValid(this.state.password) ? "" : "Password should contain 1 special character",
            confirmPasswordError: Utils.isPasswordValid(this.state.confirmPassword) ?
                (this.state.password === this.state.confirmPassword ? "" : "Passwords do not match") : "Password should contain 1 special character"
        });
        return Utils.validateEmail(this.state.email) && Utils.validateRecoverycode(this.state.recoverycode) && Utils.isPasswordValid(this.state.password)
            && Utils.isPasswordValid(this.state.confirmPassword) && this.state.password === this.state.confirmPassword;
    };

    onResetPasswordClicked = (event) => {
        event.preventDefault();
        if (this.validateResetPasswordForm())
            Utils.basicAlert("Your password has been reset successfully.")
    };

    render() {
        return (
            <ResetComponentPassword state={this.state}
                             onChangeEvent={this.onChangeEvent}
                             togglePassword={this.togglePassword}
                             onResetPasswordClicked={this.onResetPasswordClicked}/>
        );
    }
}

const mapStateToProps = (state) => {
    return {user: state.user}
};
export default connect(mapStateToProps)(ResetPassword);